<section class="content" xmlns="">
    <div class="container-fluid">
        <div class="row">
            <div class="row mt-3">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <div class="form-floating mb-3">
                            <select class="form-select" (change)="selectValue($event)">
                                <option value="">Select a Event Name</option>
                                <option *ngFor="let event of this.eventDetails" [value]="event.eventId">
                                    {{event.eventName}} -
                                    {{event.city}} -
                                    {{formattedDate(event?.eventDate)}} {{ showThankYouMail(event) ? ',( Completed)' :
                                    '' }}</option>
                            </select>
                            <label for="formId1">Event Name</label>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="form-floating mb-3">
                            <input type="text" [(ngModel)]="searchText" class="form-control"
                                placeholder="Search by Name, Email or Phone Number">
                            <label>Search</label>
                        </div>
                    </div>
                </div>

                <!-- Right Section -->
                <div class="row justify-content-end">
                    <div class="col-12 col-md-4">
                        <button class="btn btn-primary w-100 w-md-auto" (click)="generateExcelSheet()">
                           <i class="fa-solid fa-file-excel"></i> Generate Excel
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <mat-card class="order-card">
            <div class="container-fluid">
                <div class="row">
                    <mat-card-content>
                        <div class="container-fluid mt-1">
                            <div class="table-responsive table-style table-bordered">
                                <table class="table table-gray table-head-fixed">
                                    <thead class="h6">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Name</th>
                                            <th>Email Id</th>
                                            <th>City</th>
                                            <th>Overall Experience</th>
                                            <th>Most Liked</th>
                                            <th>Improvements</th>
                                            <th>Best Team Or Section</th>
                                            <th>Will Participate Again</th>
                                            <th>Additional Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="getListOfFeedbackDetails.length > 0; else noDataFound">
                                        <tr class="text-center"
                                            *ngFor="let feed of getListOfFeedbackDetails | filter : searchText; let i = index;">
                                            <td>{{ i + 1 }}</td>
                                            <td>{{feed?.name || "-"}}</td>
                                            <td>{{feed?.email || "-"}}</td>
                                            <td>{{feed?.city || "-"}}</td>
                                            <td>{{feed?.overallExperience || "-"}}</td>
                                            <td>{{feed?.mostLiked || "-"}}</td>
                                            <td>{{feed?.improvements || "-"}}</td>
                                            <td>{{feed?.bestTeamOrSection || "-"}}</td>
                                            <td>{{feed?.willParticipateAgain || "-"}}</td>
                                            <td>{{feed?.additionalComments || "-"}}</td>
                                        </tr>
                                    </tbody>
                                    <ng-template #noDataFound>
                                        <tr>
                                            <td colspan="10" class="text-center fw-bold">Data Not Found</td>
                                        </tr>
                                    </ng-template>
                                </table>
                            </div>
                        </div>
                    </mat-card-content>
                </div>
            </div>
        </mat-card>
    </div>
</section>